import script from "./AdminSideNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSideNav.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSideNav.vue?vue&type=style&index=0&id=d132fcae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d132fcae"]])

export default __exports__